import { Button } from "@/components/buttons/Button";
import { NormalText } from "@/components/text/NormalText";
import {
  type CancellationChoice,
  type CancellationReason as Reason,
} from "@/types/types";

export function CancellationReason({
  title,
  choices,
  shuffleArray,
  onChoiceSelected,
}: {
  title: string;
  choices: CancellationChoice[];
  shuffleArray: <T>(array: T[]) => T[];
  onChoiceSelected: (
    nextStep: string,
    reason: Reason,
    feedback: string | null
  ) => void;
}) {
  const shuffledChoices = shuffleArray(choices);

  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>
      <div className="space-y-2">
        {shuffledChoices.map((choice: CancellationChoice) => (
          <Button
            key={choice.reason}
            onClick={() => onChoiceSelected(choice.next, choice.reason, null)}
            className="w-full justify-start p-3"
          >
            {choice.reason}
          </Button>
        ))}
      </div>
    </div>
  );
}
